// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Expertises_wrapper__1FxE9","title":"Expertises_title__1-CO0","list":"Expertises_list__KRajP"};